import LAYOUT from '@/layouts/default/index.vue';
// 商城
export default {
  path: '/mall',
  component: LAYOUT,
  name: 'Mall',
  redirect: '/mall/duiba',
  meta: {
    title: '北京汽车',
  },
  children: [
    {
      path: 'duiba',
      name: 'MallDuiba',
      meta: {
        title: '北京汽车', // 兑吧
      },
      component: () => import('@/views/mall/duiba'),
    },
  ],
};
